import React from "react";
import { useFormContext } from 'react-hook-form'
import styles from './AnotherRentalItem.module.scss'
import cn from 'classnames'
import { Lang } from "../../../types/common-types";
import { State } from '../../../state-actions-reducers'
import accountForm from "../../../content/account-form";
import TextInput from "../TextInput/TextInput";
import DeleteButton from "../../../shared/Buttons/DeleteButton";
import FileInput from '../../../shared/Inputs/FileInput/FileInput'
import { UPLOADS_ENDPOINT } from "../../../server-parameters";
import NumberInput from "../NumberInput/NumberInput";

interface Props {
    lang: Lang;
    index: number
    disabled: boolean
    deleteHandler: () => void
    length: number;
}

export default function AnotherRentalsItem({ lang, index, disabled, deleteHandler, length }: Props) {
    const { watch, setValue, formState: { errors } } = useFormContext<State>()
    const state = watch()

    return <div className={cn('row', styles.rentals_row)}>
        <div className={'col-4 col-xs-12'}>
            <TextInput
                testName={`rentals-${index}`}
                testErrorName={`error-rentals-${index}`}
                lang={lang}
                content={accountForm.anotherRentalName}
                onChange={(e) => {
                    const updated = index < state.rentals.length
                        ? state.rentals.map((item, i) => {
                            return (index === i) ? {
                                rentalName: e,
                                rentalDiscount: state.rentals[index]?.rentalDiscount,
                                rentalDataFile: state.rentals[index]?.rentalDataFile,
                            } : item
                        }) : state.rentals.concat({
                            rentalName: e,
                            rentalDiscount: state.rentals[index]?.rentalDiscount,
                            rentalDataFile: state.rentals[index]?.rentalDataFile,
                        })
                    setValue('rentals', updated as any, { shouldDirty: true })
                }}
                value={state.rentals[index]?.rentalName}
                valid={!errors[`rentalsName${index}`]}
                disabled={disabled}
            />
        </div>
        <div className={'col-4 col-xs-12'}>
            <NumberInput
                testName={`rentals-${index}`}
                testErrorName={`error-rentals-${index}`}
                lang={lang}
                content={accountForm.anotherRentalDiscount}
                onChange={(e) => {
                    const updated = index < state.rentals.length
                        ? state.rentals.map((item, i) => {
                            return (index === i) ? {
                                rentalName: state.rentals[index]?.rentalName,
                                rentalDiscount: e,
                                rentalDataFile: state.rentals[index]?.rentalDataFile,
                            } : item
                        }) : state.rentals.concat({
                            rentalName: state.rentals[index]?.rentalName,
                            rentalDiscount: e,
                            rentalDataFile: state.rentals[index]?.rentalDataFile,
                        })
                    setValue('rentals', updated as any, { shouldDirty: true })
                }}
                value={state.rentals[index]?.rentalDiscount}
                valid={!errors[`rentalsDiscount${index}`]}
                disabled={disabled}
            />
        </div>
        <div className={'col-4 col-xs-12'}>
            <FileInput
                className={cn(length > 1 ? styles.padding_for_btn : "")}
                disabled={!state.agreed}
                lang={lang}
                url={UPLOADS_ENDPOINT}
                autorization={state.formId}
                target={state.rentals[index]?.rentalDataFile || {}}
                content={accountForm.anotherRentalFile}
                
                isSingleMode={true}
                onChange={(fileData) => {
                    const updated = state.rentals.map((item, i) =>
                        i === index ? {
                            ...item,
                            rentalDataFile: fileData
                        } : item
                    )
                    setValue('rentals', updated as any, { shouldDirty: true })
                }}
                valid={!errors[`rentalsFileName${index}`]}
                documentType="0"
                value={state.rentals[index]?.rentalDataFile?.originalFileName}
                imageErrors={state.imageError}
            />
            {length > 1 ? (
                <>
                    <DeleteButton
                        testName="deleteMessenger"
                        className={styles.deleteBtn}
                        onClick={deleteHandler}
                    />
                    <button
                        data-test-id="deleteMessenger"
                        className={styles.rentalsMobileDeleteButton}
                        onClick={() => {
                            setValue('rentals', state.rentals.filter((e, i) => i !== index) as any, { shouldDirty: true })
                        }}
                    >
                        Удалить
                    </button>
                </>
            ) : null}
        </div>
    </div>
}
